<template>
  <div>
    <h3 v-if="hasLabel" class="mb-3">{{ label }}</h3>
    <v-autocomplete
      :no-data-text="$t('realty.filters.noData')"
      :value="value"
      :item-text="itemText"
      :item-value="itemValue"
      :items="items"
      :placeholder="placeholder"
      :rules="rules"
      @change="handleSelect"
      :disabled="disabled"
      :clearable="clearable"
      autocomplete="off"
      outlined
    />
  </div>
</template>

<script>
export default {
  name: 'HAutocomplete',
  props: {
    value: {
      required: true
    },
    label: {
      type: String,
      required: false
    },
    itemText: {
      type: String,
      required: true
    },
    itemValue: {
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    placeholder: {
      type: String,
      required: false
    },
    rules: {
      required: false
    },
    disabled: {
      type: Boolean,
      default:false
    },
    clearable: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    hasLabel() {
      return this.label?.trim().length > 0
    }
  },
  methods: {
    handleSelect(value) {
      this.$emit('input', value)
    }
  }
}
</script>
